"use strict";

var sipres = document.querySelector(".pres");

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Draggable from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";

if (sipres) {

  var music = document.getElementById("background-music");
  var voice = document.getElementById("voice-audio");
  var checkBox = document.querySelector("input");

  // État sauvegardé
  var isPlaying = localStorage.getItem("musicPlaying");

  // Démarrage après interaction utilisateur
  function initializeMusic() {
    if (isPlaying === "false") {
      music.pause();
      checkBox.checked = false;
    } else {
      checkBox.checked = true;

      // Lecture après premier scroll
      const playMusicOnScroll = () => {
        music.play().catch((error) => {
          console.log("Impossible de jouer la musique automatiquement :", error);
        });
        window.removeEventListener("scroll", playMusicOnScroll);
      };

      window.addEventListener("scroll", playMusicOnScroll, { once: true });
    }
  }

  // Toggle checkbox musique
  checkBox.addEventListener("change", () => {
    if (checkBox.checked) {
      music.play().catch((error) => {
        console.log("Impossible de jouer la musique :", error);
      });
    } else {
      music.pause();
      // Couper la voix si elle est en train de jouer
      if (!voice.paused) {
        voice.pause();
        voice.currentTime = 0; // Revenir au début
      }
    }
    localStorage.setItem("musicPlaying", checkBox.checked);
  });

  // Joue la voix si #intro entre dans la vue ET le son est activé
  const introSection = document.querySelector("#intro");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && checkBox.checked) {
        voice.play().catch((error) => {
          console.log("La voix n'a pas pu être jouée :", error);
        });
        observer.unobserve(entry.target); // Ne joue qu'une seule fois
      }
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: "0px 0px -70% 0px"
  });

  observer.observe(introSection);

  // Init musique au chargement
  initializeMusic();

  // Icônes cliquables pour activer/désactiver le son
  const iconSoundOn = document.querySelector(".toggle-sound-on");
  const iconSoundOff = document.querySelector(".toggle-sound-off");

  iconSoundOn.addEventListener("click", () => {
    if (!checkBox.checked) {
      checkBox.checked = true;
      checkBox.dispatchEvent(new Event("change"));
    }
  });

  iconSoundOff.addEventListener("click", () => {
    if (checkBox.checked) {
      checkBox.checked = false;
      checkBox.dispatchEvent(new Event("change"));
    }
  });


  
  

  
  gsap.registerPlugin(ScrollTrigger);
  
  gsap.to(".gear__img", {
    rotation: 720,
    ease: "none",
    scrollTrigger: {
      trigger: ".gear",
      start: "top bottom",
      end: "bottom top",
      scrub: true,
    },
  });
  
  
  
  
  const phrases = gsap.utils.toArray(".intro__phrase");
  
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".intro",
      start: "top top",
      end: "+=200%",    // longueur scroll = 3x la hauteur viewport (ajuste selon besoin)
      scrub: true,
      pin: true,
      anticipatePin: 1,
    }
  });
  
  gsap.set(phrases, {opacity: 0});
  
  phrases.forEach((phrase, i) => {
    tl.to(phrase, {opacity: 1, duration: 0.5, ease: "power1.inOut"}, i);
    if (i !== phrases.length - 1) {
      tl.to(phrase, {opacity: 0, duration: 0.5, ease: "power1.inOut"}, i + 1);
    } else {
      // Dernière phrase reste visible à la fin
      tl.to(phrase, {opacity: 1, duration: 0.5, ease: "power1.inOut"}, i);
    }
  });
  
  

  gsap.registerPlugin(Draggable, InertiaPlugin);

  Draggable.create(".infos__img--horlogev", {
    type: "rotation",
    inertia: true,
    cursor: "grab",
    activeCursor: "grabbing"
  });
  
  Draggable.create(".infos__img--horlogel", {
    type: "rotation",
    inertia: true,
    cursor: "grab",
    activeCursor: "grabbing"
  });
  

  Draggable.create(".infos__img--livres", {
    type: "y",
    bounds: ".infos",
    inertia: true,
    edgeResistance: 0.8,
    cursor: "grab",
    activeCursor: "grabbing"
  });



  function makeDraggableWithRotation(selector) {
    const element = document.querySelector(selector);
    let lastX = 0;

    Draggable.create(element, {
      type: "x,y",
      bounds: ".infos",
      inertia: true,
      edgeResistance: 0.8,
      cursor: "grab",
      activeCursor: "grabbing",

      onDragStart: function () {
        lastX = this.x;
      },

      onDrag: function () {
        const deltaX = this.x - lastX;

        // Rotation proportionnelle au déplacement horizontal
        const rotation = Math.max(-15, Math.min(15, deltaX * 0.5));

        gsap.to(element, {
          rotation: rotation,
          duration: 0.2,
          overwrite: "auto"
        });

        lastX = this.x;
      },

      onRelease: function () {
        gsap.to(element, {
          rotation: 0,
          duration: 1,
          ease: "elastic.out(1, 0.4)"
        });
      }
    });
  }

  // Appliquer à sablier et papillon
  makeDraggableWithRotation(".infos__img--sablier");
  makeDraggableWithRotation(".infos__img--papillon");

}


var sislider = document.querySelector(".allslider");
if (sislider) {
  // Les étapes avec images fixes
  const waypoints = [
    {
      year: "Salle 1",
      title: "Salle à la Vieille Lumière",
      description:
        "Le commencement de cet escape game commence dans une salle sombre, dont la seule lumière provient d'une semblable à celle d'une vieille cave...",
      photo: "assets/images/salle1.webp"
    },
    {
      year: "Salle 2",
      title: "Salle des Horloges",
      description:
        "TicTac... c'est probablement la seule chose que vous entendrez dans cette salle remplie d'horloges ou pas...",
      photo: "assets/images/salle2.webp"
    },
    {
      year: "Salle 3",
      title: "Salle du Corbeau",
      description:
        "Un corbeau semble se faire la malle. Que cache-t-il ? À vous d'aller voir !",
      photo: "assets/images/salle3.webp"
    },
    {
      year: "Salle 4",
      title: "Salle du Voyage",
      description:
        "Cette salle porte bien son nom, c'est là que vous pourrez voyager dans la pièce, sous la seule volonté du hasard...",
      photo: "assets/images/salle4.webp"
    },
    {
      year: "Salle 5",
      title: "Salle des Souvenirs",
      description:
        "Des souvenirs plein la tête et plein les yeux. Mais encore faut-il les résoudre...",
      photo: "assets/images/salle5.webp"
    },
  ];

  // Création des slides
  const slidesContainer = document.getElementById("slides");

  waypoints.forEach((point, index) => {
    const slide = document.createElement("div");
    slide.className = "slide";
    if (index === 0) slide.classList.add("active");

    // Image en arrière-plan
    slide.style.backgroundImage = `url(${point.photo})`;
    slide.style.backgroundSize = "cover";
    slide.style.backgroundPosition = "center";

    slide.innerHTML = `
      <div class="slide__content">
        <h3>${point.year} - ${point.title}</h3>
        <p>${point.description}</p>
        <img src="${point.photo}" alt="${point.title}" class="slide__img">
      </div>
    `;
    slidesContainer.appendChild(slide);
  });

  let currentSlide = 0;
  const slides = document.querySelectorAll(".slide");
  const prevBtn = document.getElementById("prev");
  const nextBtn = document.getElementById("next");
  const journeyProgress = document.getElementById("salle-min");
  const journeyTotal = document.getElementById("salle-total");

  journeyTotal.textContent = waypoints.length;

  // Fonction pour afficher une slide
  function showSlide(index) {
    slides.forEach((s, i) => {
      s.classList.toggle("active", i === index);
    });
    journeyProgress.textContent = index + 1;
  }

  // Navigation avec boutons
  prevBtn.onclick = () => {
    currentSlide = (currentSlide === 0) ? waypoints.length - 1 : currentSlide - 1;
    showSlide(currentSlide);
  };

  nextBtn.onclick = () => {
    currentSlide = (currentSlide === waypoints.length - 1) ? 0 : currentSlide + 1;
    showSlide(currentSlide);
  };

  // Navigation clavier
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") prevBtn.click();
    if (e.key === "ArrowRight") nextBtn.click();
  });

  // Navigation avec la boussole
  const boussoleTip = document.getElementById("boussole-tip");
  const ouestDirection = document.getElementById("ouest");
  const estDirection = document.getElementById("est");

  ouestDirection.addEventListener("click", () => {
    currentSlide = (currentSlide === 0) ? waypoints.length - 1 : currentSlide - 1;
    showSlide(currentSlide);
    boussoleTip.classList.add("hidden");
  });

  estDirection.addEventListener("click", () => {
    currentSlide = (currentSlide === waypoints.length - 1) ? 0 : currentSlide + 1;
    showSlide(currentSlide);
    boussoleTip.classList.add("hidden");
  });

  // === Gestion de la boussole (rotation de l'aiguille) ===
  const boussoleContainer = document.getElementById("boussole-container");
  const needle = document.getElementById("needle");

  let previousAngle = 0;
  let rotationCount = 0;

  document.addEventListener("mousemove", (e) => {
    const boussoleRect = boussoleContainer.getBoundingClientRect();
    const boussoleCenterX = boussoleRect.left + boussoleRect.width / 2;
    const boussoleCenterY = boussoleRect.top + boussoleRect.height / 2;

    let angle =
      Math.atan2(e.clientY - boussoleCenterY, e.clientX - boussoleCenterX) *
      (180 / Math.PI);

    if (previousAngle > 150 && angle < -150) {
      rotationCount++;
    } else if (previousAngle < -150 && angle > 150) {
      rotationCount--;
    }

    previousAngle = angle;
    angle = angle + rotationCount * 360;

    needle.style.transition = "transform 0.1s ease";
    needle.style.transform = `translate(-50%, -50%) rotate(${angle + 90}deg)`;
  });

  // Afficher la première slide au démarrage
  prevBtn.focus();
  showSlide(currentSlide);
}
